import { Injectable } from '@angular/core';

import { TeamType, Roles } from '../models/enums';
import { User } from '../models/user.model';
import { Team } from '../models/team/team.model';

import { TeamEndpoint } from './team-endpoint.service';
import { TeamQueueInformation } from '../models/team/team-queue-information.model';
import { TeamQueueEdit } from '../models/team/team-queue-edit.model';
import { TeamQueueEnqueue } from '../models/team/team-queue-enqueue.model';


@Injectable({ providedIn: 'root'})
export class TeamService {

  private roleToTeamType = {
    [Roles.QCCoder]: TeamType.Coder,
    [Roles.QCSupervisor]: TeamType.Coder,
    [Roles.ReconciliationCoder]: TeamType.OdpStaff,
    [Roles.ReconciliationSupervisor]: TeamType.OdpStaff,
  };

  constructor(private teamEndpoint: TeamEndpoint) {
  }

  getActiveTeams(teamTypeId: TeamType, activeProjectId: number) {
    return this.teamEndpoint.getTeamsEndpoint<Team[]>(teamTypeId, activeProjectId);
  }

  getInactiveUsers(teamTypeId?: TeamType) {
    return this.teamEndpoint.getInactiveUsersEndpoint<User[]>(teamTypeId);
  }

  getTeamLabels(teamTypeId: TeamType, activeProjectWfId: number) {
    return this.teamEndpoint.getTeamLabelsEndpoint<string[]>(teamTypeId, activeProjectWfId);
  }

  addActiveTeam(users: User[], teamLabel: string, teamTypeId: TeamType, odpProjectWfId: number) {
    return this.teamEndpoint.getAddTeamEndpoint<Team>(users, teamLabel, teamTypeId, odpProjectWfId);
  }

  deleteTeam(teamId: number) {
    return this.teamEndpoint.getDeleteTeamEndpoint<number>(teamId);
  }

  isUserInTeam(teamTypeId?: TeamType) {
    return this.teamEndpoint.isUserInTeamEndpoint<boolean>(teamTypeId);
  }

  getTeamTypeFromRole(role: Roles): TeamType {
    return this.roleToTeamType[role];
  }

  getTeamAbstractStatus(teamId: number) {
    return this.teamEndpoint.getTeamAbstractStatusEndpoint<TeamQueueInformation>(teamId);
  }

  getAbstractGroupsByTeam(teamId: number) {
    return this.teamEndpoint.getAbstractGroupsByTeamEndpoint<TeamQueueEdit>(teamId);
  }

  saveTeamQueueChanges(model: TeamQueueEdit, teamId: number) {
    return this.teamEndpoint.saveTeamQueueChangesEndpoint<TeamQueueEdit>(model, teamId);
  }

  enqueueGroupsByTeam(teamId: number, activeProjectId: number, numGroups: number) {
    return this.teamEndpoint.enqueueGroupsByTeamEndpoint<TeamQueueEnqueue>(teamId, activeProjectId, numGroups);
  }

  getMaxAbstractGroups(teamId: number, activeProjectId: number) {
    return this.teamEndpoint.getMaxAbstractGroupsEndpoint<TeamQueueEnqueue>(teamId, activeProjectId);
  }

}
